module.exports = __webpack_public_path__ + "static/media/Vaishnavi_Mulik.c48a6905.jpg";